import { Geometry } from "geojson";
import { geoJSON } from "leaflet";
import { useMutation, useQuery } from "react-query";
import { customGet, customPost } from "utils/AxiosUtils";

export function useStudyAreaTemplateUrl() {
  async function fetch() {
    const { data } = await customGet<{ templateUrl: string }>(
      `/api/studyareas/template`
    );
    return data.templateUrl;
  }

  return useQuery(["studyareas", "template"], fetch, {
    staleTime: Infinity,
  });
}
export function useMeasureTemplateUrl(measureKey: string) {
  async function fetch() {
    const { data } = await customGet<{ templateUrl: string }>(
      `/api/measures/${measureKey}/template`
    );
    return data.templateUrl;
  }

  return useQuery(["measures", measureKey, "template"], fetch, {
    staleTime: Infinity,
  });
}

export function useUploadStudyAreaShape() {
  async function post(file: File) {
    const { data } = await customPost<{ polygon_4326: Geometry }>(
      `/api/studyareas/uploadShapeFile`,
      file,
      {
        headers: {
          "Content-Type": file.type,
        },
      }
    );
    const { polygon_4326 } = data;
    if (polygon_4326.type !== "Polygon") return null;
    // const polygonFeature: Feature = polygon(polygon_4326.coordinates);

    // const simplified = simplify(polygonFeature, {
    //   mutate: true,
    //   highQuality: true,
    //   tolerance: 0.0000001,
    // });
    // console.log("SIMPLIFIED", simplified);
    // return geoJSON(simplified);
    return geoJSON(polygon_4326);
  }
  return useMutation(["studyarea", "upload"], post, {});
}
